import React, { useEffect, useState } from "react";
import { Card, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { GET_REVIEWS } from "../../../../../services/ApiCalls";

const GuestReviews = () => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [reviewData, setReviewData] = useState(null);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        setLoading(true);
        const res = await GET_REVIEWS();
        setReviewData(res?.data?.data || null);
      } catch (err) {
        console.error("Guest reviews error", err);
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, []);

  const totalReviews = reviewData?.totalReviews || 0;
  const averageRating = reviewData?.avgRating || 0;
  const reviews = reviewData?.lastFiveReviews || [];

  return (
    <Card
      className="shadow-sm p-3 rounded-4"
      style={{ minHeight: "360px", border: "1px solid #f1f1f1" }}
    >
      {/* Header */}
      <div className="d-flex justify-content-between mb-3">
        <h6 className="fw-bold m-0">{t("dashboard.guestReviews")}</h6>
        {/* <span
          className="fw-semibold"
          style={{
            fontSize: "12px",
            color: "#e8307a",
            cursor: "pointer",
          }}
        >
          {t("dashboard.manageReviews")}
        </span> */}
      </div>

      {/* Loader */}
      {loading ? (
        <div className="d-flex justify-content-center align-items-center h-100">
          <Spinner animation="border" size="sm" />
        </div>
      ) : (
        <>
          {/* Rating Summary */}
          <div className="mb-4">
            <h1 className="fw-bold mb-1" style={{ fontSize: "3rem" }}>
              {averageRating.toFixed(1)}
            </h1>

            <div className="mb-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <span
                  key={star}
                  style={{
                    color:
                      star <= Math.round(averageRating)
                        ? "#ffc107"
                        : "#e4e5e9",
                    fontSize: "20px",
                    marginRight: "2px",
                  }}
                >
                  ★
                </span>
              ))}
            </div>

            <p className="text-muted" style={{ fontSize: "12px" }}>
              {t("dashboard.basedOnReviews", { count: totalReviews })}
            </p>
          </div>

          {/* Reviews List */}
          <div style={{ maxHeight: "180px", overflowY: "auto" }}>
            {reviews.length > 0 ? (
              reviews.map((r) => (
                <div
                  key={r._id}
                  className="d-flex justify-content-between align-items-center py-2 border-bottom"
                >
                  <div>
                    <h6
                      className="fw-semibold mb-0"
                      style={{ fontSize: "14px" }}
                    >
                      {`${r.customer?.first_name || ""} ${
                        r.customer?.last_name || ""
                      }`.trim() ||
                        t("dashboard.common.anonymous")}
                    </h6>
                    <small className="text-muted">
                      {new Date(r.createdAt).toLocaleDateString()}
                    </small>
                  </div>

                  <span
                    className="fw-bold"
                    style={{
                      background: "#fdd6e5",
                      color: "#e8307a",
                      padding: "3px 10px",
                      fontSize: "12px",
                      borderRadius: "50px",
                    }}
                  >
                    {r.rating.toFixed(1)}
                  </span>
                </div>
              ))
            ) : (
              <div className="text-center text-muted py-4">
                {t("dashboard.common.noGuestReviews")}
              </div>
            )}
          </div>
        </>
      )}
    </Card>
  );
};

export default GuestReviews;
